
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/recaptcha",
      function () {
        return require("private-next-pages/docs/errors/recaptcha.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/recaptcha"])
      });
    }
  